import { useEffect, useState } from 'react'
import useKrpano from 'react-krpano-hooks'



const useKrpanoJs = () => {
  const [showLoadingPage, setShowLoadingPage] = useState(true)
  const [currentScene, setCurrentScene] = useState('')
  const {
    containerRef,
    krpanoState: { isLoaded },
  } = useKrpano({
    globalFunctions: {
      logScene: (scene) => {
        setCurrentScene(scene)
      },
    },
  })

  // Debounce hide loading page
  useEffect(() => {
    if (isLoaded) {
      setTimeout(() => {
        setShowLoadingPage(false)
      }, 1000)
    }
  }, [isLoaded])

  

  return {
    showLoadingPage,
    isLoaded,
    containerRef,
    currentScene,
  }
}

export default useKrpanoJs
